/**
 * Controlled PWA install flow — captures beforeinstallprompt for custom UI.
 */
import { perfTimeline } from '../utils/startupPerf';

let deferredPrompt = null;
const listeners = new Set();

function notifyListeners() {
  const available = Boolean(deferredPrompt);
  listeners.forEach((fn) => {
    try {
      fn(available);
    } catch (_) {}
  });
}

export function initInstallPrompt() {
  if (typeof window === 'undefined') return;

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    perfTimeline('pwa.installPromptAvailable', 'pwa', { available: true });
    notifyListeners();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    perfTimeline('pwa.installed', 'pwa');
    notifyListeners();
  });
}

export function subscribeInstallAvailability(onChange) {
  listeners.add(onChange);
  onChange(Boolean(deferredPrompt));
  return () => listeners.delete(onChange);
}

export function isInstallPromptAvailable() {
  return Boolean(deferredPrompt);
}

export async function triggerInstall() {
  if (!deferredPrompt) {
    perfTimeline('pwa.installTriggered', 'pwa', { outcome: 'unavailable' });
    return { outcome: 'unavailable' };
  }

  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  notifyListeners();
  perfTimeline('pwa.installTriggered', 'pwa', { outcome });
  return { outcome };
}

export function isStandaloneDisplayMode() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true
  );
}
